

import Swiper, { Navigation } from 'swiper'

import 'swiper/css'
import 'swiper/css/navigation'

class ProjectsGal {
  constructor(elements, settings) {
    this.elements = elements
    this.settings = settings

    this.init()
  }

  defineSlider() {
    this.slider = new Swiper(this.elements.slider, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 24,
      navigation: this.elements.navigation,
      allowTouchMove: true,
      breakpoints: {
        480: {
          slidesPerView: 1.6
        },
        667: {
          slidesPerView: 2
        },
        768: {
          slidesPerView: 1.6
        },
        1024: {
          slidesPerView: 2
        },
        1280: {
          slidesPerView: 3
        }
      }
    })
  }

  init() {
    this.defineSlider()
  }
}

const projectsSectionsList = document.querySelectorAll('.service-gal')

projectsSectionsList.forEach(item => {
  new ProjectsGal({
    slider: item,
    navigation: {
      prevEl: item.querySelector('.service-arrows__arrow-prev'),
      nextEl: item.querySelector('.service-arrows__arrow-next'),
    }
  })
})